const Image = ({ ...props }) => {
  return <img className="image" alt="img" {...props} />;
};

export default Image;
